<template>
	<div>
		<div class="tops-between title">
			<div class="tops-title">
				<p>经营数据</p>
			</div>
		</div>
		<div class="home-center">
			<div class="times">
				<p class="label">选择时间：</p>
				<v-date @time="timeChange"></v-date>
			</div>
			<!-- <p class="title">经营数据</p> -->
			<div class="boxs">
				<el-row class="rows">
					<el-col
						:span="4"
						v-for="(item, index) in amount"
						:key="index"
						class="cols"
					>
						<span class="icon">{{ item.itemValue }}</span>
						<p class="name">{{ item.itemName }}</p>
					</el-col>
				</el-row>
			</div>
		</div>
		<div class="mains-bottom">
			<div class="back el-icon-back" @click="back"></div>
		</div>
	</div>
</template>

<script>
import minxin from '../../../assets/javascript/minxin.js'
export default {
	components: {},
	mixins: [minxin],
	data() {
		return {
			appInfo: this.$store.getters.AppInfo,
			amount: [],
			query: {},
			beginTime: new Date(),
			endTime: new Date(),
		}
	},
	// mixins: [minxin],

	computed: {},

	created() {
		this.$store.commit('setSwitchShopInfo', true)
	},
	destroyed() {
		this.$store.commit('setSwitchShopInfo', false)
	},
	methods: {
		back() {
			this.$router.push('/dataList')
		},
		init() {
			this.$api
				.post(this.$url.report.summary, {
					beginTime: this.beginTime,
					endTime: this.endTime,
				})
				.then((res) => {
					if (res) {
						this.amount = res
					}
					// this.pageDetailByShop();
				})
		},
		timeChange(value) {
			this.beginTime = this.formatDay(value[0])
			this.endTime = this.formatDay(value[1])
			this.init()
		},
		handleClick(item) {
			this.$router.push(item.path)
		},
	},
}
</script>

<style lang="less" scoped>
@import '../../../assets/css/edit.less';
/deep/ .title {
	border-top: 0;
}
.home-center {
	.times {
		display: flex;
		align-items: center;
		padding: 20px 30px;
		background: #fff;
		margin-bottom: 10px;
	}
	.boxs {
		display: flex;
		flex-wrap: wrap;
		background: #fff;
		padding: 0 30px 30px;
		.box {
			width: 200px;
			height: 120px;
			margin: 0 20px 20px 0;
			color: #fff;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			.icon {
				font-size: 37px;
			}
			.name {
				margin-top: 13px;
				font-size: 20px;
			}
		}
		.rows {
			width: 100%;
			.cols {
				margin-top: 30px;
				text-align: center;
				.name {
					color: #333;
					font-weight: bold;
					margin: 5px 0 10px;
				}
				.icon {
					color: #336fed;
				}
			}
		}
	}
}
.mains-bottom {
	.back {
		position: absolute;
		left: 26px;
	}
	width: calc(100% - 30px);
	position: absolute;
	background-color: #fff;
	height: 62px;
	margin-top: 10px;
	padding: 0 26px;
	display: flex;
	align-items: center;
	justify-content: center;
	bottom: 15px;
	box-sizing: border-box;
	.last-btn {
		margin-left: 22px;
	}
}
</style>
